import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { WidgetCheckboxV0NodeDto } from '../models/widget-checkbox-v0-node.dto';
import { ColDef, ColumnApi, GetDataPath, GridApi, ITooltipParams, SelectionChangedEvent } from 'ag-grid-community';
import { IoniconsOutline } from '@pt/pt-models';
import { TreeNode } from '@pt/tree';

@Component({
  selector: 'pt-widget-checkbox-v0-tree',
  templateUrl: './widget-checkbox-v0-tree.component.html',
  styleUrls: ['./widget-checkbox-v0-tree.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetCheckboxV0TreeComponent implements OnChanges, AfterViewInit {
  @ViewChild('nameCol', { static: true }) nameCol: TemplateRef<unknown>;

  @Input() checkbox: WidgetCheckboxV0NodeDto[];
  @Input() showShowOnlySelectedFilter = false;
  @Output() changeSelectedRowId = new EventEmitter<string[]>();

  public removeNode = [];
  public IconClose = IoniconsOutline.close;
  public IconSearch = IoniconsOutline.search;
  public currentFilter: string;
  public filterChecked = false;
  public treeData: TreeNode[];

  public rowHeight = 24;
  public floatingFiltersHeight = 30;
  public headerHeight = 50;
  // public tableHeight = 300;
  public gridApi: GridApi;
  public columnApi: ColumnApi;
  public searchId = 'checkboxTreeFilterId';

  public columnDefs: ColDef[] = [];
  public defaultColDef: ColDef = {
    flex: 1,
    floatingFilter: true
  };
  public autoGroupColumnDef: ColDef = {
    field: 'label',
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    headerClass: 'd-none',
    headerName: '',
    minWidth: 300,
    suppressMenu: true,
    tooltipField: 'help',
    tooltipValueGetter: (params: ITooltipParams) => {
      if (params?.data?.help) {
        return params.data.help;
      }
      return '';
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRendererParams: {
      suppressCount: true,
      checkbox: true
    }
  };
  public rowData: TreeCheckboxData[] = [];
  public groupDefaultExpanded = 0;

  ngAfterViewInit(): void {
    this.columnDefs = [];
    setTimeout(() => {
      document.getElementById(this.searchId)?.focus();
    }, 500);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    this.gridApi.showLoadingOverlay();
    this.gridApi.forEachNode(node => {
      if (node.data?.checked) {
        node.setSelected(true);
        this.gridApi.ensureIndexVisible(node.rowIndex);
      }
    });
    setTimeout(() => {
      this.gridApi.collapseAll();
      this.gridApi.hideOverlay();
    }, 500);
  }

  public getDataPath: GetDataPath = (data: TreeCheckboxData) => {
    return data.path;
  };

  ngOnChanges(): void {
    this.populateTable();
    this.initTreeData();
  }

  private widgetCheckboxV0NodeDtoToGfmiTreeNode(c: WidgetCheckboxV0NodeDto): TreeNode | undefined {
    if (c) {
      const children = [];
      c?.children?.forEach(cc => {
        const v = this.widgetCheckboxV0NodeDtoToGfmiTreeNode(cc);
        if (v) {
          children.push(v);
        }
      });
      const node: TreeNode = {
        uuid: c.uuid,
        label: c.label,
        help: c.help,
        checked: c.checked,
        children: children
      };
      return node;
    }
    return undefined;

  }

  private initTreeData() {
    this.treeData = [];
    this.checkbox?.forEach((c: WidgetCheckboxV0NodeDto) => {
      this.treeData.push(this.widgetCheckboxV0NodeDtoToGfmiTreeNode(c));
    });
  }

  selectionChanged($event: SelectionChangedEvent) {
    const selectedId: string[] = this.gridApi.getSelectedNodes()?.filter((n) => !!n.data.uuid).map(n => n.data.uuid);
    this.changeSelectedRowId.emit(selectedId);
  }

  public search(value: string) {
    this.currentFilter = value;
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.currentFilter);
      if (this.currentFilter && this.currentFilter.length > 0) {
        this.gridApi.expandAll();
      } else {
        this.gridApi.collapseAll();
      }
    }
  }

  public reset() {
    this.currentFilter = '';
    this.filterChecked = false;
    this.search(this.currentFilter);
  }

  applyFilter(filterChecked: boolean) {
    if (filterChecked) {
      this.gridApi.forEachNode(n => {
        if (!n.isSelected()) {
          this.removeNode.push(n.data);
        }
      });
      this.gridApi.applyTransaction({ remove: this.removeNode });
      this.gridApi.expandAll();
    } else {
      if (this.removeNode.length > 0) {
        this.gridApi.applyTransaction({ add: this.removeNode });
        this.removeNode = [];
        this.gridApi.collapseAll();
      }
    }

  }

  private populateTable() {
    // const rootNumber = this.checkbox.length;
    // this.tableHeight = (Math.min(10, Math.max(5, rootNumber)) * this.rowHeight) + 5 + this.floatingFiltersHeight;
    const data: TreeCheckboxData[] = [];
    this.checkbox.forEach(root => {
      data.push({
        path: [root.label],
        uuid: root.uuid,
        label: root.label,
        help: root.help,
        checked: root.checked
      });
      let isAllChecked = root.children.length > 0;

      root.children.forEach(children => {
        if (!children.checked) {
          isAllChecked = false;
        }
        data.push({
          path: [root.label, children.label],
          uuid: children.uuid,
          label: children.label,
          help: children.help,
          checked: children.checked
        });
      });
      // data.push({
      //   path: [root.label],
      //   uuid: root.uuid,
      //   label: root.label,
      //   help: root.help,
      //   checked: isAllChecked
      // });
    });
    this.rowData = data;
  }

}

export interface TreeCheckboxData {
  path: string[];
  uuid: string;
  label: string;
  help: string;
  checked: boolean;
}
